import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import store from 'store/index';
import { getUser } from 'selectors';
import env from '@beam-australia/react-env';

const API_KEY = env('BUGSNAG_API_KEY');
const VERSION = env('VERSION');

if (API_KEY) {
  Bugsnag.start({
    apiKey: API_KEY,
    appVersion: VERSION,
    plugins: [new BugsnagPluginReact()],
    onError: (event) => {
      const state = store.getState();
      const user = getUser(state);
      event.addMetadata('state', state);
      event.addMetadata('user', user);
    },
  });
}

export const notifyBugsnagClient = (error, callback = (event) => event) => {
  Bugsnag.notify(new Error(error), callback);
};

export const ErrorBoundary = API_KEY
  ? Bugsnag.getPlugin('react').createErrorBoundary(React)
  : ({ children }) => children;
